import React, {Component} from 'react';
import {Row, Col} from "reactstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as constants from "../../const/constants";
import Timetable from '../../assets/img/revamp/edulab/Time-Table---Miss-Jumana.jpg'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import {Carousel} from "react-responsive-carousel";
import './TimeTable.scss'

class TimetableView extends Component {

    render() {
        return (
            <div className="container pt-3 pb-6 ">
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <div className='text-center'>
                            <h1 className='main-topic'>
                                Class Schedule
                            </h1>
                            <Col className='timetable mb-2' sm={12} md={12} lg={12} xl={12}>
                                <div className='timeTableView'>
                                    <Carousel autoPlay showThumbs={false} showStatus={false} >
                                        <div>
                                            {/*<img className={"blur-img"} src={Timetable}/>*/}
                                            <img className={"slideshow-pro-image"} src={Timetable}/>
                                        </div>
                                    </Carousel>
                                </div>
                            </Col>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default TimetableView;
